import React, { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Building2, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

export default function Register() {
  const { user, register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "agent" });
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await register(form);
    setBusy(false);
    if (!res.ok) toast.error(res.error);
    else toast.success("Account creato con successo");
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-muted/30">
      <Card className="w-full max-w-md border-border/60 shadow-sm p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-md bg-primary flex items-center justify-center">
            <Building2 className="w-5 h-5 text-white" />
          </div>
          <span className="font-heading font-semibold tracking-tight">LOOK OFF MARKET</span>
        </div>
        <h2 className="font-heading text-2xl font-semibold tracking-tight">Crea il tuo account</h2>
        <p className="text-sm text-muted-foreground mt-1">Inizia a lavorare sulle opportunità off-market.</p>

        <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="register-form">
          <div className="space-y-2">
            <Label htmlFor="name">Nome completo</Label>
            <Input id="name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Mario Rossi" data-testid="register-name-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="mario@azienda.it" data-testid="register-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required minLength={6} value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="Almeno 6 caratteri" data-testid="register-password-input" />
          </div>
          <div className="space-y-2">
            <Label>Ruolo</Label>
            <Select value={form.role} onValueChange={(v) => setForm({ ...form, role: v })}>
              <SelectTrigger data-testid="register-role-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="agent">Agente immobiliare</SelectItem>
                <SelectItem value="client">Cliente / Investitore</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <Button type="submit" disabled={busy} className="w-full gap-2" data-testid="register-submit-button">
            {busy ? "Creazione…" : (<>Crea account <ArrowRight className="w-4 h-4" /></>)}
          </Button>
        </form>

        <p className="text-sm text-muted-foreground text-center mt-6">
          Hai già un account?{" "}
          <Link to="/login" className="text-primary hover:underline font-medium" data-testid="register-login-link">
            Accedi
          </Link>
        </p>
      </Card>
    </div>
  );
}
